import { Accordion } from '@/components/Accordion';
import { useIsCrawler } from '@/hooks';
import { cn } from '@/utils';

import FaqItem from './FaqItem';

function FaqsAccordion({
	children,
	faqList,
	className,
	defaultValue = [],
	contentClassName,
	container = true
}) {
	const isCrawler = useIsCrawler();

	const faqsDefaultValueList = faqList.map((_, index) => {
		return 'faq-' + (index + 1);
	});

	return (
		<div
			className={cn(
				'flex w-full flex-col items-center lg:max-w-[814px]',
				container && 'container',
				className
			)}
		>
			{children}
			<div className="inline-flex w-full flex-col items-start justify-start">
				<Accordion
					defaultValue={isCrawler ? faqsDefaultValueList : defaultValue}
					type={isCrawler ? 'multiple' : 'single'}
					collapsible
					className="w-full"
					isFaqs
				>
					{faqList.map((faq, index) => {
						return (
							<FaqItem
								value={faqsDefaultValueList[index]}
								question={faq.question}
								answer={faq.answer}
								key={index + faq.question}
								contentClassName={contentClassName}
							/>
						);
					})}
				</Accordion>
			</div>
		</div>
	);
}

export default FaqsAccordion;
